import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchUsuarios } from "../../../store/slices/alumnos/index.js";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Modal, Spinner, Image } from "react-bootstrap";
import imgLogIn from "../../../assets/images/logocolegio.png";

function LoginForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [mail, setMail] = useState(() => localStorage.getItem("mail") || "");
  const [clave, setClave] = useState("");
  const [loginError, setLoginError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [shakeForm, setShakeForm] = useState(false);

  const validate = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!mail) errors.mail = "El campo email es obligatorio.";
    else if (!emailRegex.test(mail)) errors.mail = "Ingrese un email válido.";

    if (!clave) errors.clave = "El campo contraseña es obligatorio.";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    const datosUsuario = { mail, clave };

    dispatch(
      fetchUsuarios(
        datosUsuario,
        (data) => {
          setIsLoading(false);
          if (data) {
            localStorage.setItem("mail", mail);
            setLoginError(false);
            navigate("/inicio");
          } else {
            setLoginError(true);
          }
        },
        () => {
          setIsLoading(false);
          setLoginError(true);
          setShakeForm(true);
          setTimeout(() => setShakeForm(false), 500);
        }
      )
    );
  };

  return (
    <Container className="min-vh-100 d-flex justify-content-center align-items-center" data-aos="fade-up">
      <Row className="w-100 align-items-center justify-content-center" style={{ maxWidth: "1100px" }}>
        {/* Columna izquierda */}
        <Col md={6} className="text-center mb-5 mb-md-0">
          <Image src={imgLogIn} alt="Logo" fluid style={{ maxWidth: "200px" }} />
          <div className="mt-5">
            <a href="contacto" className="text-white fw-bold d-block mb-3 text-decoration-underline">
              ¿Has olvidado la contraseña?
            </a>
            <p className="text-white fw-bold">
              ¿Querés ser parte de nuestra Institución?
              <a href="contacto" className="text-warning text-decoration-underline ms-2">Contacto</a>
            </p>
          </div>
        </Col>

        {/* Columna derecha: formulario */}
        <Col md={6}>
          <div className="p-5 bg-white rounded-4 shadow-lg">
            <Form onSubmit={handleSubmit} className={shakeForm ? "shake" : ""}>
              <h3 className="text-center mb-4 text-success fw-bold">AUTOGESTIÓN FAMILIAS</h3>

              {/* Email */}
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  className={`p-3 shadow-sm rounded-pill ${
                    validationErrors.mail || loginError ? "is-invalid" : ""
                  }`}
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  required
                />
                {validationErrors.mail && (
                  <div className="invalid-feedback d-block">{validationErrors.mail}</div>
                )}
              </Form.Group>

              {/* Password */}
              <Form.Group className="mb-4">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Contraseña"
                  className={`p-3 shadow-sm rounded-pill ${
                    validationErrors.clave || loginError ? "is-invalid" : ""
                  }`}
                  value={clave}
                  onChange={(e) => setClave(e.target.value)}
                  required
                />
                {validationErrors.clave && (
                  <div className="invalid-feedback d-block">{validationErrors.clave}</div>
                )}
                {loginError && !validationErrors.clave && (
                  <div className="invalid-feedback d-block">Credenciales incorrectas.</div>
                )}
              </Form.Group>

              {/* Botón de envío */}
              <div className="text-center">
                <Button
                  type="submit"
                  variant="success"
                  className="px-5 py-2 fw-bold rounded-pill"
                  style={{ transition: "all 0.3s ease" }}
                  onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}

                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Validando...
                    </>
                  ) : (
                    "INGRESAR"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>

      {/* Modal de error */}
      <Modal show={showModalError} onHide={() => setShowModalError(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Error en el inicio de sesión. Verificá tus credenciales.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalError(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default LoginForm;
